(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/engine/assets/javascripts/actions.js') >= 0) return;  svs.modules.push('/components/tipsen/engine/assets/javascripts/actions.js');
"use strict";

var _svs$core$config$data, _svs$core$config$data2;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  createAction,
  createAsyncThunk
} = RTK;
const {
  selectWager,
  selectWagers,
  selectWagerProps,
  selectCoupon,
  selectPrice,
  selectAllSigns,
  selectCouponBoardEmpty,
  selectIsRelatedCouponValid,
  selectCurrentAddonPixSizeIndex,
  selectBoardUserSigns,
  selectIsEveryMatchSelectedWithUserSigns,
  selectExternalSystemChunkSize,
  selectRelatedDrawCoupon
} = svs.components.tipsen.engine.selectors.couponSelectors;
const {
  placeBetService,
  generateSportPixService
} = svs.components.tipsen.engine.services;
const {
  generateSportkryssNumber
} = svs.components.tipsen.engine.utils;
const {
  XPERT_WAGER_RSYS,
  XPERT_WAGER_MSYS
} = svs.components.tipsen.engine.constants.xpertWagerSystemTypes;
const {
  COUPON_SINGLEROWS
} = svs.components.tipsen.engine.constants.couponTypes;
const {
  selectRSystems,
  selectAddonPixSizes
} = svs.components.tipsen.engine.selectors.engineSelectors;
const {
  selectEngineDefinition,
  selectEngineDefinitionByProductId
} = svs.components.tipsen.engine.selectors;
const {
  userSession
} = svs.core;
const {
  WALLET_ID_PLAYER,
  WALLET_ID_SELFSERVICE
} = svs.components.tipsen.wallet.walletId;
const {
  selectById
} = svs.components.sport.drawsRedux.globalizedSelectors;
const {
  CurrencyFromJupiterString
} = svs.utils.format;
const {
  EventTypeId
} = svs.components.sportinfo.common.constants;
const {
  externalSystemsType,
  externalSystemsBoardsType,
  SportPixWagerSystemTypes,
  wagerSystemTypes
} = svs.components.tipsen.engine.constants;
const {
  getLogger
} = svs.core.log;
const {
  jupiter
} = svs.core;
const {
  makeSelectRelatedDraw
} = svs.components.sport.drawsRedux.selectors;
const {
  LoadingKeys
} = svs.components.tipsen.loadingState.constants;
const {
  getTitleAndErrorMessageFromWagerResponse
} = svs.components.tipsen.engine.errorHelpers;
const {
  dialog
} = svs.components;
const {
  actions,
  PARAM_ACTION,
  signIndexToOutcome,
  TipsenModuleGameUrl
} = svs.components.sport.tipsenShared;
const {
  transferRowsMW
} = svs.components.paymentMiddlewares.middlewareTransferRows;
const {
  selectWagersScore,
  selectWagersGoalCount,
  selectWagers1x2
} = svs.components.tipsen.engine.createWagers;
const {
  productIds
} = svs.utils.products;
const {
  wagerPaymentFlow
} = svs.components;
const {
  marketplaceFlow,
  executePayment,
  standardFlow
} = wagerPaymentFlow;
const {
  WALLET_MARKETPLACE_RETAILER
} = svs.components.tipsen.wallet.walletType;
const {
  formatDate
} = svs.components.lbUtils.helpers;
const switchEngine = createAction('tipsen/switchEngine');
const toggleAlternative = createAction('tipsen/toggleAlternative');
const toggleOutcome = createAction('tipsen/toggleOutcome');
const setExternalCoupon = createAction('tipsen/setExternalCoupon');
const selectBetAmount = createAction('tipsen/selectBetAmount');
const setSportkryssFactorIndex = createAction('tipsen/setSportkryssFactorIndex');
const setSportkryssNumber = createAction('tipsen/setSportkryssNumber');
const clearCoupon = createAction('tipsen/clearCoupon');
const clearCouponBoard = createAction('tipsen/clearCouponBoard');
const selectWeek = createAction('tipsen/selectWeek');
const selectPixSize = createAction('tipsen/selectPixSize');
const selectSystem = createAction('tipsen/selectSystem');
const toggleMSign = createAction('tipsen/toggleMSign');
const setCouponValues = createAction('tipsen/setCouponValues');
const resetWithCouponValues = createAction('tipsen/resetWithCouponValues');
const setSignDistribution = createAction('tipsen/setSignDistribution');
const setReduceModeCount = createAction('tipsen/setReduceModeCount');
const toggleReduction = createAction('tipsen/toggleReduction');
const addCouponValues = createAction('tipsen/addCouponValues');
const isSelfService = (_svs$core$config$data = (_svs$core$config$data2 = svs.core.config.data.svsconfig) === null || _svs$core$config$data2 === void 0 ? void 0 : _svs$core$config$data2.isSelfService) !== null && _svs$core$config$data !== void 0 ? _svs$core$config$data : false;
const wagerLogger = getLogger('tipsen:wager');
const showErrorDialog = (message, title) => {
  const dialogOptions = {
    branding: svs.components.dialog.branding.SPORT,
    title: title ? title : 'Något gick fel!',
    icon: 'exclamation-sign',
    area: dialog.area.POPUP,
    type: dialog.type.ERROR,
    message: [{
      type: dialog.message.TEXT,
      text: message
    }],
    actions: [{
      title: 'Ok',
      callback: () => {
        dialog.api.close();
      }
    }]
  };

  dialog.api.add(new svs.components.dialog.Confirm(dialogOptions));
};
const getTotalPaidSum = paidWagers => paidWagers.reduce((sum, wager) => {
  sum += CurrencyFromJupiterString(wager.wagerAmounts.totalAmount);
  return sum;
}, 0);
const _generateSportPixCoupon = async (_ref, _ref2) => {
  let {
    productId,
    drawNumber,
    system,
    boards = [0],
    couponId,
    baseRow,
    keepUserSigns = false,
    xpertAnalysisAuthorId = null,
    overwriteCoupon = true,
    type 
  } = _ref;
  let {
    getState
  } = _ref2;
  let rSystem;
  const state = getState();
  const isSingleRows = type === wagerSystemTypes.SROW;
  let guaranteedEvents = isSingleRows ? {
    rows: []
  } : {};
  const completedRows = []; 
  let filteredArray = boards;
  if (keepUserSigns || baseRow && !isSingleRows) {
    var _definition$outcomes$;
    const definition = selectEngineDefinitionByProductId(productId);
    const eventTypeId = (_definition$outcomes$ = definition === null || definition === void 0 ? void 0 : definition.outcomes.eventTypeId) !== null && _definition$outcomes$ !== void 0 ? _definition$outcomes$ : EventTypeId.EVENT_1X2;
    filteredArray = boards.filter(boardIndex => {
      const isBoardValidWithUserSigns = selectIsEveryMatchSelectedWithUserSigns(state, couponId, boardIndex);
      if (isSingleRows && isBoardValidWithUserSigns) {
        const signs = selectBoardUserSigns(state, couponId, boardIndex);
        completedRows.push({
          index: boardIndex,
          signs
        });
        return false;
      }
      return true;
    });
    const signsForEventType = Object.values(signIndexToOutcome[eventTypeId]);
    for (let boardIndex = 0; boardIndex < filteredArray.length; boardIndex++) {
      let signs;
      if (!isSingleRows && baseRow) {
        signs = baseRow;
      } else {
        signs = selectBoardUserSigns(state, couponId, filteredArray[boardIndex]);
      }
      const guaranteedEvent = {
        events: []
      };
      signs.forEach((signRow, i) => {
        if (signRow.find(sign => sign)) {
          const outcomes = [];
          signRow.forEach((sign, signIndex) => {
            if (sign) {
              outcomes.push({
                value: signsForEventType[signIndex]
              });
            }
          });
          guaranteedEvent.events.push({
            eventNumber: i + 1,
            outcomes
          });
        }
      });
      isSingleRows ? guaranteedEvents.rows.push(_objectSpread({
        pixNumber: guaranteedEvents.rows.length + 1
      }, guaranteedEvent)) : guaranteedEvents = guaranteedEvent;
    }
  }
  if (type === XPERT_WAGER_RSYS) {
    const rSystems = selectRSystems(state);
    if (!rSystems.includes(system)) {
      throw new Error("Not a valid RSYS: ".concat(system, ". Avail: ").concat(rSystems.join(', ')));
    }
    rSystem = system;
  }
  const systemType = SportPixWagerSystemTypes[type];
  const signs = await generateSportPixService({
    productId,
    drawNumber,
    size: system,
    guaranteedEvents,
    systemType,
    numRows: filteredArray.length
  });
  const boardSigns = {};
  filteredArray.forEach((board, index) => {
    boardSigns[board] = signs[index];
  });
  if (completedRows.length) {
    completedRows.forEach(row => {
      boardSigns[row.index] = row.signs;
    });
  }
  return {
    boardSigns,
    couponId,
    keepUserSigns,
    rSystem,
    system: undefined,
    xpertAnalysisAuthorId,
    overwriteCoupon
  };
};
const generateSportPixCoupon = createAsyncThunk('tipsen/generateSportPixCoupon', async (_ref3, _ref4) => {
  let {
    data
  } = _ref3;
  let {
    getState
  } = _ref4;
  const {
    productId,
    drawNumber,
    system,
    type,
    numRows = 1,
    couponId,
    baseRow = [],
    keepUserSigns = false,
    xpertAnalysisAuthorId = null
  } = data;
  const boards = [];
  for (let i = 0; i < numRows; i++) {
    boards.push(i);
  }
  return _generateSportPixCoupon({
    productId,
    drawNumber,
    system,
    type,
    boards,
    couponId,
    baseRow,
    keepUserSigns,
    xpertAnalysisAuthorId,
    overwriteCoupon: true
  }, {
    getState
  });
});
const generateSportPixCouponBoard = createAsyncThunk('tipsen/generateSportPixCoupon', async (_ref5, _ref6) => {
  let {
    productId,
    drawNumber,
    system,
    type,
    boardIndex = 0,
    couponId,
    baseRow = [],
    keepUserSigns = false,
    xpertAnalysisAuthorId = null
  } = _ref5;
  let {
    getState
  } = _ref6;
  return _generateSportPixCoupon({
    productId,
    drawNumber,
    system,
    type,
    boards: [boardIndex],
    couponId,
    baseRow,
    keepUserSigns,
    xpertAnalysisAuthorId,
    overwriteCoupon: false
  }, {
    getState
  });
});
const getWager = _ref7 => {
  let {
    state,
    draw,
    couponId,
    isPlayingCompetition,
    competition,
    isCompetitionSignUp
  } = _ref7;
  const wager = selectWager(state, draw, couponId, isPlayingCompetition, competition);
  const wagerProps = selectWagerProps(state, draw, couponId, isPlayingCompetition, isPlayingCompetition && isCompetitionSignUp, competition, null);
  wagerProps.extradata = _objectSpread(_objectSpread({}, wagerProps.extradata), isSelfService && {
    regCloseTime: draw.regCloseTime
  });
  return [wager, wagerProps];
};
const {
  isMarketplaceWallet
} = svs.components.tipsen.wallet.walletHelpers;
const {
  selectActiveWallet
} = svs.components.tipsen.walletSelectors;
const {
  groupTypes
} = svs.components.marketplaceData.constants;
const placeBetSingle = async _ref8 => {
  var _engine$defaultCoupon;
  let {
    state,
    draw,
    couponId,
    signs,
    engine,
    isPlayingCompetition,
    isCompetitionSignUp,
    competition,
    primaryWallet,
    relatedCouponId,
    selectedPixIndex
  } = _ref8;
  const [wager, wagerProps] = getWager({
    state,
    draw,
    couponId,
    isPlayingCompetition,
    competition,
    isCompetitionSignUp
  });
  const wagersToPay = [wager];
  const wagersPropsToPay = [wagerProps];
  const draws = [draw];
  const coupon = selectCoupon(state, couponId);
  let relatedWager;
  let relatedWagerProps;
  const wallet = selectActiveWallet(state);
  if (relatedCouponId && !isMarketplaceWallet(wallet) && selectedPixIndex) {
    const relatedDraw = makeSelectRelatedDraw(draw.productId, draw.drawNumber, 'PIX')(state) || {};
    [relatedWager, relatedWagerProps] = getWager({
      state,
      draw: relatedDraw,
      couponId: relatedCouponId,
      isPlayingCompetition: false,
      competition,
      isCompetitionSignUp,
      shouldPayRelatedCoupon: false
    });
    if (!selectIsRelatedCouponValid(state, relatedCouponId)) {
      relatedWager.errorPay = true;
    }
    wagersToPay.push(relatedWager);
    wagersPropsToPay.push(relatedWagerProps);
    draws.push(relatedDraw);
  }
  const price = wagerProps.message.price;
  const productName = wagersPropsToPay.map(wagerprop => wagerprop.message.product);
  let wagerResponses;
  try {
    const wagerRespons = await placeBetService(wagersToPay, wagersPropsToPay, draws); 
    wagerResponses = [].concat(wagerRespons);
  } catch (err) {
    const errorCode = parseInt(String(err.error.code).replace(/\s/g, ''), 10);
    const {
      errorMessage,
      title
    } = getTitleAndErrorMessageFromWagerResponse(errorCode);
    showErrorDialog(errorMessage, title);
    throw err.error;
  }
  let errorWagers = [];
  const isMoreThanOneWagerResponse = Array.isArray(wagerResponses);
  if (isMoreThanOneWagerResponse && wagersToPay.length !== wagerResponses.length || !isMoreThanOneWagerResponse && wagersToPay.length > 1) {
    const successfulWagers = [].concat(wagerResponses);
    const startIndex = wagersToPay.length - successfulWagers.length;
    errorWagers = wagersPropsToPay.slice(startIndex);
  }
  return {
    couponId,
    primaryWallet,
    price,
    productName,
    signs,
    isSingleRows: ((coupon === null || coupon === void 0 ? void 0 : coupon.boards.length) || 0) > 1,
    sportkryssNumber: generateSportkryssNumber(),
    wagerResponses,
    reduceModeCount: (_engine$defaultCoupon = engine.defaultCouponValues) === null || _engine$defaultCoupon === void 0 ? void 0 : _engine$defaultCoupon.reduceModeCount,
    compDesc: isPlayingCompetition && competition ? competition.compDesc : undefined,
    competitionSignedUp: isPlayingCompetition && isCompetitionSignUp,
    isPlayingCompetition,
    errorWagers
  };
};

const placeBetExternal = async _ref9 => {
  var _engine$defaultCoupon2;
  let {
    state,
    draw,
    couponId,
    signs,
    engine,
    isPlayingCompetition,
    isCompetitionSignUp,
    competition,
    primaryWallet
  } = _ref9;
  const coupon = selectCoupon(state, couponId);
  const wagers = selectWagers(state, draw, couponId, isPlayingCompetition, competition);
  let price = selectPrice(state, couponId);
  const getDisplayNameByDraw = selectEngineDefinition(state).getDisplayNameByDraw;
  const productName = getDisplayNameByDraw(draw);
  const wagerResponses = [];
  const failedWagers = [];
  const selectNumberOfBoards = coupon.boards.length;
  const wallet = selectActiveWallet(state);
  const isMarketplace = isMarketplaceWallet(wallet) ? wallet.label : null;
  const selectSystem = coupon.boards[0].type;
  const externalSystemTotalWagerMaxSize = selectExternalSystemChunkSize(state, couponId);
  if (isMarketplace && selectNumberOfBoards > externalSystemTotalWagerMaxSize) {
    const marketPlaceText = 'som läggs för lag (Spela tillsammans)';
    const message = selectSystem === externalSystemsBoardsType[externalSystemsType.SINGLE] ? "Externa systemspel ".concat(marketPlaceText, " kan inte vara st\xF6rre \xE4n ").concat(externalSystemTotalWagerMaxSize, " enkelrader.") : "M-system (matematiskt system) ".concat(marketPlaceText, " kan inte vara st\xF6rre \xE4n ").concat(externalSystemTotalWagerMaxSize, " rader vid externt systemspel.");
    const CustomException = {
      message,
      name: 'customError'
    };
    throw CustomException;
  }
  for (let wagerIndex = 0; wagerIndex < wagers.length; wagerIndex++) {
    const chunkData = wagers.length > 1 ? {
      index: wagerIndex,
      total: wagers.length
    } : undefined;
    const wagerProps = selectWagerProps(state, draw, couponId, isPlayingCompetition, isPlayingCompetition && isCompetitionSignUp, competition, chunkData);
    wagerProps.extradata = _objectSpread(_objectSpread(_objectSpread({}, wagerProps.extradata), isSelfService && {
      regCloseTime: draw.regCloseTime
    }), {}, {
      externalSystem: true
    });
    try {
      const response = await placeBetService(wagers[wagerIndex], wagerProps, draw, Boolean(chunkData));
      wagerResponses.push(response);
    } catch (err) {
      failedWagers.push(wagers[wagerIndex]);
      break;
    }
  }
  if (failedWagers.length > 0) {
    price = getTotalPaidSum(wagerResponses);
  }
  const successfulWagerClientSerials = wagerResponses.map(res => res.wagerClientSerial).join(',');
  if (coupon.guid && coupon.isExternal) {
    const options = {
      method: 'PUT',
      path: "/wager/1/ownwager/".concat(coupon.guid, "/paid"),
      data: {
        wagerSerials: successfulWagerClientSerials
      }
    };
    jupiter.call(options, () => {}, err => {
      wagerLogger.error("/wager/1/ownwager/".concat(coupon.guid, "/paid with serials: ").concat(successfulWagerClientSerials, " failed with error"), err);
    });
  }
  return {
    couponId,
    primaryWallet,
    price,
    productName,
    signs,
    isSingleRows: (coupon === null || coupon === void 0 ? void 0 : coupon.boards[0].type) === externalSystemsBoardsType[externalSystemsType.SINGLE],
    sportkryssNumber: generateSportkryssNumber(),
    wagerResponses,
    reduceModeCount: (_engine$defaultCoupon2 = engine.defaultCouponValues) === null || _engine$defaultCoupon2 === void 0 ? void 0 : _engine$defaultCoupon2.reduceModeCount,
    compDesc: isPlayingCompetition && competition ? competition.compDesc : undefined,
    competitionSignedUp: isPlayingCompetition && isCompetitionSignUp,
    isPlayingCompetition,
    failedWagers
  };
};
const getRelatedCoupon = createAsyncThunk('tipsen/getRelatedCoupon', async (_ref10, _ref11) => {
  let {
    relatedCouponId,
    couponId
  } = _ref10;
  let {
    getState,
    dispatch
  } = _ref11;
  const state = getState();
  const coupon = selectCoupon(state, couponId);
  const {
    productId,
    drawNumber
  } = coupon || {};
  const selectedPixIndex = selectCurrentAddonPixSizeIndex(state, relatedCouponId);
  const relatedDraw = makeSelectRelatedDraw(productId, drawNumber, 'PIX')(state) || {};
  if (relatedCouponId && selectedPixIndex && relatedDraw) {
    const pixSizes = selectAddonPixSizes(state);
    try {
      const options = {
        system: pixSizes[selectedPixIndex],
        productId: relatedDraw.productId,
        drawNumber: relatedDraw.drawNumber,
        couponId: relatedCouponId,
        type: XPERT_WAGER_MSYS,
        baseRow: [],
        keepUserSigns: false
      };
      await dispatch(generateSportPixCoupon({
        data: options,
        loadingMeta: {
          key: LoadingKeys.PIX,
          pause: 200
        }
      })).unwrap();
    } catch (err) {
      wagerLogger.info("Error dispatching pix for related coupon: ".concat(err));
    }
  }
});

const placeBet = createAsyncThunk('tipsen/placeBet', async (_ref12, _ref13) => {
  let {
    productId,
    drawNumber,
    couponId,
    isPlayingCompetition = false,
    isCompetitionSignUp = false,
    competition = null,
    relatedCouponId
  } = _ref12;
  let {
    getState,
    dispatch
  } = _ref13;
  let state = getState();
  const draw = selectById(state, "".concat(productId, "_").concat(drawNumber));
  let primaryWallet = null;
  if (userSession.hasRole(userSession.roles.PLAYER)) {
    primaryWallet = WALLET_ID_PLAYER;
  } else if (isSelfService) {
    primaryWallet = WALLET_ID_SELFSERVICE;
  }
  const coupon = selectCoupon(state, couponId);
  const engine = selectEngineDefinition(state);
  if (coupon.isExternal) {
    const signs = selectAllSigns(state, couponId);
    return await placeBetExternal({
      state,
      draw,
      couponId,
      signs,
      engine,
      isPlayingCompetition,
      isCompetitionSignUp,
      competition,
      primaryWallet
    });
  }
  const selectedPixIndex = selectCurrentAddonPixSizeIndex(state, relatedCouponId);
  if (relatedCouponId) {
    await dispatch(getRelatedCoupon({
      relatedCouponId,
      couponId
    }));
    state = getState();
  }
  const signs = ((coupon === null || coupon === void 0 ? void 0 : coupon.boards) || []).map(board => board.signs).filter((board, index) => !selectCouponBoardEmpty(state, couponId, index));
  return await placeBetSingle({
    state,
    draw,
    couponId,
    signs,
    engine,
    isPlayingCompetition,
    isCompetitionSignUp,
    competition,
    primaryWallet,
    relatedCouponId,
    selectedPixIndex
  });
});
const getWagerFunc = productId => {
  switch (productId) {
    case productIds.BOMBEN:
      return selectWagersScore;
    case productIds.STRYKTIPSET:
    case productIds.EUROPATIPSET:
    case productIds.T8STRYK:
    case productIds.T8EXTRA:
    case productIds.T8:
    case productIds.POWERPLAY:
      return selectWagers1x2;
    case productIds.FULLTRAFF:
      return selectWagersGoalCount;
    default:
  }
};

const placeWager = createAsyncThunk('tipsen/placeWager', async (_ref14, _ref15) => {
  let {
    couponId,
    isTransferable
  } = _ref14;
  let {
    getState,
    dispatch
  } = _ref15;
  let state = getState();
  const coupon = selectCoupon(state, couponId);
  const {
    productId
  } = coupon;
  const relatedCoupon = selectRelatedDrawCoupon(state, couponId);
  let relatedCouponId;
  if (relatedCoupon) {
    const {
      productId: relatedProductId,
      drawNumber: relatedDrawNumber
    } = relatedCoupon;
    relatedCouponId = "".concat(relatedProductId, "_").concat(relatedDrawNumber, "_pix");
  }
  const wagers = [];
  const wallet = state.Wallet.wallets[state.Wallet.activeWallet] || undefined;
  const isMPWallet = isMarketplaceWallet(wallet);
  let activatedDrawId;
  let role;
  let commissionPercent;
  if (isMPWallet) {
    const externalSystemTotalWagerMaxSize = selectExternalSystemChunkSize(state, couponId);
    if (coupon.isExternal && coupon.boards.length > externalSystemTotalWagerMaxSize) {
      const marketPlaceText = 'som läggs för lag (Spela tillsammans)';
      const selectSystem = coupon.boards[0].type;
      const message = selectSystem === externalSystemsBoardsType[externalSystemsType.SINGLE] ? "Externa systemspel ".concat(marketPlaceText, " kan inte vara st\xF6rre \xE4n ").concat(externalSystemTotalWagerMaxSize, " enkelrader.") : "M-system (matematiskt system) ".concat(marketPlaceText, " kan inte vara st\xF6rre \xE4n ").concat(externalSystemTotalWagerMaxSize, " rader vid externt systemspel.");
      const CustomException = {
        message,
        name: 'customError'
      };
      throw CustomException;
    }
    if (wallet.type === WALLET_MARKETPLACE_RETAILER) {
      activatedDrawId = wallet.meta.activatedDrawId;
      role = groupTypes.RETAILER;
      commissionPercent = wallet.meta.commissionPercent;
    } else {
      activatedDrawId = wallet.meta.ActivatedDrawId;
      role = groupTypes.PRIVATE;
    }
  }
  let createWagerFunc = getWagerFunc(productId);
  wagers.push(...createWagerFunc(state, couponId, activatedDrawId, commissionPercent, role));
  if (relatedCouponId) {
    await dispatch(getRelatedCoupon({
      relatedCouponId,
      couponId
    }));
    state = getState();
    if (selectIsRelatedCouponValid(state, relatedCouponId)) {
      const relatedCoupon = selectCoupon(state, relatedCouponId);
      const {
        productId: relatedProductId
      } = relatedCoupon;
      createWagerFunc = getWagerFunc(relatedProductId);
      wagers.push(...createWagerFunc(state, relatedCouponId, undefined, undefined, undefined, productId)); 
    }
  }
  const queryParams = new URLSearchParams(window.location.search);
  queryParams.set(PARAM_ACTION, actions.PAY);
  const paymentContext = {
    userContext: {
      returnQuery: queryParams
    }
  };
  if (isSelfService && wagerPaymentFlow.selfServiceFlow) {
    const regCloseTimes = wagers.map(wager => {
      var _selectById;
      const productId = wager.bets[0].productId;
      const drawNumber = wager.bets[0].drawNumber;
      return formatDate.formatDate((_selectById = selectById(state, "".concat(productId, "_").concat(drawNumber))) === null || _selectById === void 0 ? void 0 : _selectById.regCloseTime, true, true);
    });
    const wagerCount = await wagerPaymentFlow.selfServiceFlow.createSelfServicePaymentFlow({
      wagers,
      regCloseTimes
    });
    return {
      wagerCount,
      totalWagerCount: wagers.length
    };
  }
  let paymentBuilder;
  if (isMPWallet) {
    const isC2C = Boolean(role === groupTypes.PRIVATE);
    paymentBuilder = marketplaceFlow.createMarketplacePaymentFlow({
      config: {
        haltPaymentOnException: true
      },
      wagers,
      isC2C
    });
  } else {
    const isSingleRows = couponId.includes(COUPON_SINGLEROWS);
    const gameUrlOptions = isSingleRows ? {
      subPath: "/".concat(TipsenModuleGameUrl.SINGLES)
    } : {};
    const extraPostMW = [];
    if (isTransferable) {
      extraPostMW.push(transferRowsMW(gameUrlOptions));
    }
    paymentBuilder = standardFlow.createStandardPaymentFlow({
      config: {
        haltPaymentOnException: true
      },
      wagers,
      extraPostMW
    });
  }
  const [result, error] = await executePayment.executePayment(paymentBuilder, paymentContext);
  const sportkryssNumber = generateSportkryssNumber();
  const successfulWagerClientSerials = result.getTransactionIds();
  if (coupon.guid && coupon.isExternal && successfulWagerClientSerials.length > 0) {
    const options = {
      method: 'PUT',
      path: "/wager/1/ownwager/".concat(coupon.guid, "/paid"),
      data: {
        wagerSerials: successfulWagerClientSerials
      }
    };
    jupiter.call(options, () => {}, err => {
      wagerLogger.error("/wager/1/ownwager/".concat(coupon.guid, "/paid with serials: ").concat(successfulWagerClientSerials, " failed with error"), err);
    });
  }
  return {
    result,
    error,
    sportkryssNumber,
    relatedCouponId
  };
});
setGlobal('svs.components.tipsen.engine.actions', {
  switchEngine,
  toggleAlternative,
  setExternalCoupon,
  selectBetAmount,
  setSportkryssFactorIndex,
  setSportkryssNumber,
  placeBet,
  placeWager,
  clearCoupon,
  clearCouponBoard,
  selectWeek,
  selectSystem,
  toggleMSign,
  generateSportPixCoupon,
  generateSportPixCouponBoard,
  setCouponValues,
  resetWithCouponValues,
  setSignDistribution,
  setReduceModeCount,
  toggleReduction,
  selectPixSize,
  toggleOutcome,
  addCouponValues
});

 })(window);